import { mainGet } from '../net/mainApi';

export const getStoredSession = () => {
    return {
        clid: localStorage.getItem('clid'),
        key: localStorage.getItem('key')
    };
};

export const checkUserBySession = async () => {
    const { clid, key } = getStoredSession();
    if (!clid || !key) return null;

    const response = await mainGet({ type: 'checkuser', id: clid, pass: key });
    if (!response?.data?.ok) return null;

    return response.data.data;
};
